import { getDecisions } from './useDecisions';
import { getDissertations } from './useDissertations';
import { getNormas } from './useNormas';
import { getPublications } from './usePublications';

export type Search = {
  search_text?: string;
  initialDate?: string;
  finalDate?: string;
  categoria?: string;
  indice?: string;
}

export enum categorias {
  normas_juridicas="Normas Jurídicas",
  decisoes_judiciais="Decisões Judiciais",
  teses_dissertacoes="Teses e Dissertações",
  publicacoes="Publicações Selecionadas"
}

function formatThesesDate(date: string) {
  return date.split('-')[0];
}

export async function getGeneralResults(search: Search | null = null) {
  const decisionsPromise = getDecisions({
    search_text: search?.search_text,
    indice: search?.indice,
    initialDateJulgamento: search?.initialDate,
    finalDateJulgamento: search?.finalDate,
    initialDatePublicacao: search?.initialDate,
    finalDatePublicacao: search?.finalDate,
  });

  const normasPromise = getNormas({
    search_text: search?.search_text,
    index: search?.indice,
    initialDate: search?.initialDate,
    finalDate: search?.finalDate,
  });

  const dissertationsPromise = getDissertations({
    buscaLivre: search?.search_text,
    indice: search?.indice,
    initialDate: search?.initialDate? `${formatThesesDate(`${search?.initialDate}`)}-01-01` : search?.initialDate,
    finalDate: search?.finalDate? `${formatThesesDate(`${search?.finalDate}`)}-12-31` : search?.finalDate
  });

  const publicationsPromise = getPublications({
    buscaLivre: search?.search_text,
    indice: search?.indice,
    initialDate: search?.initialDate,
    finalDate: search?.finalDate
  });

  const emptyValue = {
    results: [],
    pagination: {

    }
  }

  switch (search?.categoria) {
    case categorias.decisoes_judiciais:
      return {
        decisions: await decisionsPromise,
        normas: emptyValue,
        dissertations: emptyValue,
        publications: emptyValue
      }
    case categorias.normas_juridicas:
      return {
        decisions: emptyValue,
        normas: await normasPromise,
        dissertations: emptyValue,
        publications: emptyValue
      }
    case categorias.teses_dissertacoes:
      return {
        decisions: emptyValue,
        normas: emptyValue,
        dissertations: await dissertationsPromise,
        publications: emptyValue
      }
    case categorias.publicacoes:
      return {
        decisions: emptyValue,
        normas: emptyValue,
        dissertations: emptyValue,
        publications: await publicationsPromise
      }
    default:
      return {
        decisions: await decisionsPromise,
        normas: await normasPromise,
        dissertations: await dissertationsPromise,
        publications: await publicationsPromise
      }
  }
}

